/**
 * Default / Shared > Form
 */

import Form from '../../../../shared/components/form';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler   from '../../../../shared/dom/event-handler';

const resetRanges = (form) => {
	const collection = SelectorEngine.find('input[type="range"]', form);

	for (const element of collection) {
		const valMin   = parseInt((element.getAttribute('min') ?? 0), 10);
		const valReset = parseInt((element.dataset.resetValue ?? 0), 10);
		const val      = valReset ?? valMin;

		element.setAttribute('value', val);
	}
};

// ------
// Public
// ------

const init = () => {
	Form.init();

	const resetButtons = SelectorEngine.find('form [type="reset"]');

	for (const button of resetButtons) {
		const form = SelectorEngine.parents(button, 'form');

		if (form[0]) {
			EventHandler.on(button, `click.formReset`, (event) => {
				form[0].reset();

				resetRanges(form[0]);
			});
		}
	}
};

// Export
export default init;
